/** Maps language aliases (keys) to canonical display names (values). */
export const LANGUAGE_ALIASES: Record<string, string> = {
  // English
  English: "English",
  Anglais: "English",
  Inglés: "English",
  Inglês: "English",
  Inglese: "English",
  Englisch: "English",

  // Spanish
  Spanish: "Español",
  Español: "Español",
  Castellano: "Español",
  Espagnol: "Español",
  Spanisch: "Español",
  Spagnolo: "Español",

  // French
  French: "Français",
  Français: "Français",
  Francés: "Français",
  Französisch: "Français",
  Francese: "Français",

  // German
  German: "Deutsch",
  Deutsch: "Deutsch",
  Alemán: "Deutsch",
  Allemand: "Deutsch",
  Tedesco: "Deutsch",

  // Portuguese
  Portuguese: "Português",
  Português: "Português",
  Portugués: "Português",
  Portugais: "Português",
  Portoghese: "Português",

  // Italian
  Italian: "Italiano",
  Italiano: "Italiano",
  Italien: "Italiano",
  Italienisch: "Italiano",

  // Dutch
  Dutch: "Nederlands",
  Nederlands: "Nederlands",
  Holandés: "Nederlands",
  Néerlandais: "Nederlands",
  Olandese: "Nederlands",

  // Russian
  Russian: "Русский",
  Русский: "Русский",
  Russe: "Русский",
  Ruso: "Русский",
  Russisch: "Русский",

  // Chinese
  Chinese: "中文",
  Mandarin: "中文",
  中文: "中文",
  汉语: "中文",
  Chinois: "中文",
  Chino: "中文",
  Chinesisch: "中文",

  // Japanese
  Japanese: "日本語",
  日本語: "日本語",
  Japonais: "日本語",
  Japonés: "日本語",
  Giapponese: "日本語",

  // Korean
  Korean: "한국어",
  한국어: "한국어",
  Coréen: "한국어",
  Coreano: "한국어",

  // Arabic
  Arabic: "العربية",
  العربية: "العربية",
  Arabe: "العربية",
  Árabe: "العربية",
  Arabisch: "العربية",

  // Hindi
  Hindi: "हिन्दी",
  हिन्दी: "हिन्दी",
  हिंदी: "हिन्दी",

  // Turkish
  Turkish: "Türkçe",
  Türkçe: "Türkçe",
  Turc: "Türkçe",
  Turco: "Türkçe",
  Türkisch: "Türkçe",

  // Ukrainian
  Ukrainian: "Українська",
  Українська: "Українська",
  Ukrainien: "Українська",
  Ucraniano: "Українська",

  // Polish
  Polish: "Polski",
  Polski: "Polski",
  Polonais: "Polski",
  Polaco: "Polski",
  Polnisch: "Polski",

  // Czech
  Czech: "Čeština",
  Čeština: "Čeština",
  Tchèque: "Čeština",
  Checo: "Čeština",
  Tschechisch: "Čeština",

  // Romanian
  Romanian: "Română",
  Română: "Română",
  Roumain: "Română",
  Rumano: "Română",
  Rumänisch: "Română",

  // Hungarian
  Hungarian: "Magyar",
  Magyar: "Magyar",
  Hongrois: "Magyar",
  Húngaro: "Magyar",
  Ungarisch: "Magyar",

  // Swedish
  Swedish: "Svenska",
  Svenska: "Svenska",
  Suédois: "Svenska",
  Sueco: "Svenska",
  Schwedisch: "Svenska",

  // Norwegian
  Norwegian: "Norsk",
  Norsk: "Norsk",
  Norvégien: "Norsk",
  Noruego: "Norsk",
  Norwegisch: "Norsk",

  // Danish
  Danish: "Dansk",
  Dansk: "Dansk",
  Danois: "Dansk",
  Danés: "Dansk",
  Dänisch: "Dansk",

  // Finnish
  Finnish: "Suomi",
  Suomi: "Suomi",
  Finnois: "Suomi",
  Finés: "Suomi",
  Finnisch: "Suomi",

  // Greek
  Greek: "Ελληνικά",
  Ελληνικά: "Ελληνικά",
  Grec: "Ελληνικά",
  Griego: "Ελληνικά",
  Griechisch: "Ελληνικά",

  // Hebrew
  Hebrew: "עברית",
  עברית: "עברית",
  Hébreu: "עברית",
  Hebreo: "עברית",
  Hebräisch: "עברית",

  // Indonesian
  Indonesian: "Bahasa Indonesia",
  "Bahasa Indonesia": "Bahasa Indonesia",
  Indonésien: "Bahasa Indonesia",
  Indonesio: "Bahasa Indonesia",

  // Vietnamese
  Vietnamese: "Tiếng Việt",
  "Tiếng Việt": "Tiếng Việt",
  Vietnamien: "Tiếng Việt",
  Vietnamita: "Tiếng Việt",

  // Thai
  Thai: "ไทย",
  ไทย: "ไทย",
  Thaï: "ไทย",
  Tailandés: "ไทย",

  // Persian
  Persian: "فارسی",
  Farsi: "فارسی",
  فارسی: "فارسی",
  Persan: "فارسی",
  Persa: "فارسی",

  // Serbian
  Serbian: "Srpski",
  Srpski: "Srpski",
  Serbe: "Srpski",
  Serbio: "Srpski",
  Serbisch: "Srpski",

  // Croatian
  Croatian: "Hrvatski",
  Hrvatski: "Hrvatski",
  Croate: "Hrvatski",
  Croata: "Hrvatski",
  Kroatisch: "Hrvatski",

  // Bulgarian
  Bulgarian: "Български",
  Български: "Български",
  Bulgare: "Български",
  Búlgaro: "Български",
  Bulgarisch: "Български",

  // Slovak
  Slovak: "Slovenčina",
  Slovenčina: "Slovenčina",
  Slovaque: "Slovenčina",
  Eslovaco: "Slovenčina",
  Slowakisch: "Slovenčina",

  // Slovenian
  Slovenian: "Slovenščina",
  Slovenščina: "Slovenščina",
  Slovène: "Slovenščina",
  Esloveno: "Slovenščina",
  Slowenisch: "Slovenščina",

  // Lithuanian
  Lithuanian: "Lietuvių",
  Lietuvių: "Lietuvių",
  Lituanien: "Lietuvių",
  Lituano: "Lietuvių",
  Litauisch: "Lietuvių",

  // Latvian
  Latvian: "Latviešu",
  Latviešu: "Latviešu",
  Letton: "Latviešu",
  Letón: "Latviešu",
  Lettisch: "Latviešu",

  // Estonian
  Estonian: "Eesti",
  Eesti: "Eesti",
  Estonien: "Eesti",
  Estonio: "Eesti",
  Estnisch: "Eesti",

  // Catalan
  Catalan: "Català",
  Català: "Català",
  Catalán: "Català",
  Catalane: "Català",
  Katalanisch: "Català",

  // Galician
  Galician: "Galego",
  Galego: "Galego",
  Galicien: "Galego",
  Gallego: "Galego",
  Galizisch: "Galego",

  // Basque
  Basque: "Euskara",
  Euskara: "Euskara",
  Vasco: "Euskara",
  Baskisch: "Euskara",

  // Afrikaans
  Afrikaans: "Afrikaans",

  // Swahili
  Swahili: "Kiswahili",
  Kiswahili: "Kiswahili",

  // Bengali
  Bengali: "বাংলা",
  বাংলা: "বাংলা",
  Bangla: "বাংলা",

  // Tamil
  Tamil: "தமிழ்",
  தமிழ்: "தமிழ்",

  // Telugu
  Telugu: "తెలుగు",
  తెలుగు: "తెలుగు",

  // Marathi
  Marathi: "मराठी",
  मराठी: "मराठी",

  // Gujarati
  Gujarati: "ગુજરાતી",
  ગુજરાતી: "ગુજરાતી",

  // Punjabi
  Punjabi: "ਪੰਜਾਬੀ",
  ਪੰਜਾਬੀ: "ਪੰਜਾਬੀ",

  // Urdu
  Urdu: "اردو",
  اردو: "اردو",

  // Malay
  Malay: "Melayu",
  Melayu: "Melayu",
  Malais: "Melayu",
  Malayo: "Melayu",
  Malaiisch: "Melayu",

  // Tagalog
  Tagalog: "Tagalog",
  Filipino: "Tagalog",

  // Icelandic
  Icelandic: "Íslenska",
  Íslenska: "Íslenska",
  Islandais: "Íslenska",
  Islandés: "Íslenska",
  Isländisch: "Íslenska",

  // Irish
  Irish: "Gaeilge",
  Gaeilge: "Gaeilge",
  Irlandais: "Gaeilge",
  Irlandés: "Gaeilge",
  Irisch: "Gaeilge",

  // Welsh
  Welsh: "Cymraeg",
  Cymraeg: "Cymraeg",
  Gallois: "Cymraeg",
  Galés: "Cymraeg",
  Walisisch: "Cymraeg",

  // Albanian
  Albanian: "Shqip",
  Shqip: "Shqip",
  Albanais: "Shqip",
  Albanés: "Shqip",
  Albanisch: "Shqip",

  // Bosnian
  Bosnian: "Bosanski",
  Bosanski: "Bosanski",
  Bosniaque: "Bosanski",
  Bosnio: "Bosanski",
  Bosnisch: "Bosanski",

  // Macedonian
  Macedonian: "Македонски",
  Македонски: "Македонски",
  Macédonien: "Македонски",
  Macedonio: "Македонски",
  Mazedonisch: "Македонски",

  // Georgian
  Georgian: "ქართული",
  ქართული: "ქართული",
  Géorgien: "ქართული",
  Georgiano: "ქართული",
  Georgisch: "ქართული",

  // Armenian
  Armenian: "Հայերեն",
  Հայերեն: "Հայերեն",
  Arménien: "Հայերեն",
  Armenio: "Հայերեն",
  Armenisch: "Հայերեն",

  // Azerbaijani
  Azerbaijani: "Azərbaycan",
  Azərbaycan: "Azərbaycan",
  Azéri: "Azərbaycan",
  Azerí: "Azərbaycan",
  Aserbaidschanisch: "Azərbaycan",

  // Kazakh
  Kazakh: "Қазақ",
  Қазақ: "Қазақ",

  // Uzbek
  Uzbek: "Oʻzbek",
  Oʻzbek: "Oʻzbek",
  Ouzbek: "Oʻzbek",

  // Kyrgyz
  Kyrgyz: "Кыргызча",
  Кыргызча: "Кыргызча",
  Kirghiz: "Кыргызча",

  // Tajik
  Tajik: "Тоҷикӣ",
  Тоҷикӣ: "Тоҷикӣ",
  Tadjik: "Тоҷикӣ",

  // Belarusian
  Belarusian: "беларуская",
  беларуская: "беларуская",
  Biélorusse: "беларуская",
  Bielorruso: "беларуская",
  Weißrussisch: "беларуская",

  // Mongolian
  Mongolian: "Монгол",
  Монгол: "Монгол",
  Mongol: "Монгол",

  // Luxembourgish
  Luxembourgish: "Lëtzebuergesch",
  Lëtzebuergesch: "Lëtzebuergesch",
  Luxembourgeois: "Lëtzebuergesch",

  // Maltese
  Maltese: "Malti",
  Malti: "Malti",
  Maltais: "Malti",
  Maltés: "Malti",
  Maltesisch: "Malti",

  // Cebuano
  Cebuano: "Cebuano",

  // Amharic
  Amharic: "አማርኛ",
  አማርኛ: "አማርኛ",

  // Kannada
  Kannada: "ಕನ್ನಡ",
  ಕನ್ನಡ: "ಕನ್ನಡ",

  // Malayalam
  Malayalam: "മലയാളം",
  മലയാളം: "മലയാളം",

  // Burmese
  Burmese: "မြန်မာ",
  မြန်မာ: "မြန်မာ",
  Birman: "မြန်မာ",

  // Khmer
  Khmer: "ខ្មែរ",
  ខ្មែរ: "ខ្មែរ",
  Cambodgien: "ខ្មែរ",

  // Lao
  Lao: "ລາວ",
  ລາວ: "ລາວ",
  Laotien: "ລາວ",

  // Nepali
  Nepali: "नेपाली",
  नेपाली: "नेपाली",
  Népalais: "नेपाली",

  // Sinhala
  Sinhala: "සිංහල",
  සිංහල: "සිංහල",
  Cinghalais: "සිංහල",

  // Pashto
  Pashto: "پښتو",
  پښتو: "پښتو",

  // Kurdish
  Kurdish: "Kurdî",
  Kurdî: "Kurdî",
  Kurde: "Kurdî",
  Kurdo: "Kurdî",
};

export const CANONICAL_LANGUAGES = Array.from(
  new Set(Object.values(LANGUAGE_ALIASES))
).sort((a, b) => a.localeCompare(b));

const aliasLookup = new Map<string, string>(
  Object.entries(LANGUAGE_ALIASES).map(([alias, canonical]) => [
    alias.toLowerCase(),
    canonical,
  ])
);

const canonicalLookup = new Map<string, string>(
  CANONICAL_LANGUAGES.map((lang) => [lang.toLowerCase(), lang])
);

/** Resolve any alias or variant to its canonical display name. */
export function toCanonicalLanguage(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) return trimmed;

  const fromAlias = aliasLookup.get(trimmed.toLowerCase());
  if (fromAlias) return fromAlias;

  const fromCanonical = canonicalLookup.get(trimmed.toLowerCase());
  if (fromCanonical) return fromCanonical;

  return trimmed;
}

/** Search canonical languages, optionally limited to a subset (e.g. languages spoken by masters). */
export function searchCanonicalLanguages(
  query: string,
  pool?: string[]
): string[] {
  const q = query.trim().toLowerCase();
  const allowed = pool
    ? new Set(pool.map(toCanonicalLanguage))
    : null;

  const addMatch = (canonical: string, results: Set<string>) => {
    const resolved = toCanonicalLanguage(canonical);
    if (allowed && !allowed.has(resolved)) return;
    results.add(resolved);
  };

  const results = new Set<string>();

  if (!q) {
    const source = allowed ? Array.from(allowed) : CANONICAL_LANGUAGES;
    return source.sort((a, b) => a.localeCompare(b));
  }

  for (const [alias, canonical] of Object.entries(LANGUAGE_ALIASES)) {
    if (alias.toLowerCase().includes(q) || canonical.toLowerCase().includes(q)) {
      addMatch(canonical, results);
    }
  }

  const directPool = allowed ? Array.from(allowed) : CANONICAL_LANGUAGES;
  for (const lang of directPool) {
    if (lang.toLowerCase().includes(q)) {
      addMatch(lang, results);
    }
  }

  return Array.from(results).sort((a, b) => a.localeCompare(b));
}

/** Whether a master speaks a given canonical language (matches aliases too). */
export function masterSpeaksLanguage(
  masterLanguages: string[] | null | undefined,
  canonicalLang: string
): boolean {
  const target = toCanonicalLanguage(canonicalLang);
  return (
    masterLanguages?.some((lang) => toCanonicalLanguage(lang) === target) ??
    false
  );
}

/** Whether a language string matches a free-text search query (via aliases). */
export function languageMatchesQuery(lang: string, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;

  const canonical = toCanonicalLanguage(lang);
  if (canonical.toLowerCase().includes(q)) return true;

  for (const [alias, value] of Object.entries(LANGUAGE_ALIASES)) {
    if (value === canonical && alias.toLowerCase().includes(q)) return true;
  }

  return lang.toLowerCase().includes(q);
}
